import type { NuxtApp } from '#app'

const pending = new WeakSet<NuxtApp>()

export const identityStartupInitialization = {
  request(nuxtApp: NuxtApp): void {
    pending.add(nuxtApp)
  },
  isRequested(nuxtApp: NuxtApp): boolean {
    return pending.has(nuxtApp)
  },
  consume(nuxtApp: NuxtApp): boolean {
    return pending.delete(nuxtApp)
  }
}
